import styled from 'styled-components';

export const HvacFormContainer = styled.div`
  width: 100%;
  height: auto;
  padding: 50px 28px 40px;
  background: #fff;
  box-shadow: 0px 15px 40px rgba(0, 0, 0, 0.1);
  .hvac-form--description {
    max-width: 810px;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    text-align: right;
    color: var(--neutral-text-color);
    margin: 0 auto 24px;
  }

  .hvac-form--form {
    max-width: 810px;
    margin: 0 auto;

    .hvac-form--form-item {
      margin-bottom: 39px;
    }
  }
  .seers-calc-drop-down .ant-select-show-arrow {
    height: 56px;
    .ant-select-selection--single {
      height: 58px !important;

      div {
        height: 100% !important;
        border-radius: 0;
      }
    }
    .ant-select-selection-selected-value {
      position: relative;
      top: 15px;
    }
  }
  .sticky-container {
    height: 100%;
    @media (max-width: 768px) {
      height: 1200px;
    }
    @media (max-width: 480px) {
      height: auto;
    }
  }
  .hvac-form-right-container {
    margin-left: 30px;
    padding: 20px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: var(--blue-fourth);
    border: 1px solid #cfd8dc;
    position: sticky;
    top: 0;
    .p {
      width: 350px;
    }

    .seers-results-heading {
      font-size: 20px;
    }

    .seers-results-sub-heading {
      font-size: 16px;
      color: var(--tertiary-hover-color);
    }

    .hvac-form-right-gate-container {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }

    .hvac-form--subscribe-form {
      display: block;
      margin-bottom: 50px;
      margin-left: auto;
      margin-right: auto;
      input {
        width: 270px;
        height: 55px !important;
      }
      button {
        background-color: #009de6;
        font-size: 20px;
        line-height: 110%;
        text-align: center;
        letter-spacing: -0.01em;
        color: #ffffff;
        font-weight: 300;
        width: 270px;
        margin-left: 0;
      }
    }

    .hvac-form-map-image {
      width: 100%;
    }
    .hvac-form-map-description {
      margin-top: 30px;
    }
    .hvac-form-total-calculation {
      text-align: center;
      .hvac-form-total-btu-range {
        margin-top: 40px;
        font-size: 20px;
        font-weight: bold;
      }
    }

    .savings-circle-graph-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      background-color: #ffffff;
      border: 1px solid #cfd8dc;
      padding: 20px;

      .savings-item-column {
        width: 50%;
        display: flex;
        flex-direction: column;
        margin: auto 0;
        text-align: right;

        .savings-percent-text-container {
          position: absolute;
          top: 180px;
          left: 79px;
          text-align: center;
          h3 {
            line-height: 25%;
          }
          p {
            font-size: 13px;
          }
        }
        .savings-result-span {
          font-weight: bold;
          font-size: 20px;
        }
        .savings-result-span.savings-new-cost {
          color: var(--blue-primary);
        }
        h6 {
          margin-bottom: 20px;
        }
        p {
          font-size: 16px;
          font-weight: normal;
          line-height: 100%;
        }

        .circular-chart-bottom {
          display: block;
          margin: 0 auto;
          max-height: 150px;
          max-width: 150px;
          position: absolute;
          left: 54px;
        }

        .circular-chart {
          display: block;
          margin: 0 auto;
          max-width: 150px;
          max-height: 150px;
          z-index: 1000;
        }

        .circle {
          stroke: var(--blue-6);
          margin: 0 auto;
          fill: none;
          stroke-width: 2.8;
          stroke-linecap: round;
          animation: progress 1s ease-out forwards;
        }

        .circle-bottom {
          stroke: var(--disabled-text-color);
          fill: none;
          stroke-width: 2.8;
          stroke-linecap: round;
          animation: progress 1s ease-out forwards;
        }

        @keyframes progress {
          0% {
            stroke-dasharray: 0 100;
          }
        }
      }
    }
    .savings-bar-graph-container {
      ul {
        padding-inline-start: 0px;
      }
      .savings-bar-graph {
        display: table;
        table-layout: fixed;
        width: 100%;
        max-width: 700px;
        height: 300px;
        margin: 0 auto;
        border-bottom: 2px solid var(--blue-6);
        margin-bottom: 30px;

        li {
          position: relative;
          display: table-cell;
          vertical-align: bottom;
          height: 200px;
        }

        span {
          margin: 0 1em;
          display: block;
          background: var(--blue-6);
          animation: draw 1s ease-in-out;
          text-align: center;

          &:before {
            position: absolute;
            left: 0;
            right: 0;
            top: 100%;
            padding: 5px 1em 0;
            display: block;
            text-align: center;
            content: attr(title);
            word-wrap: break-word;
            text-transform: uppercase;
            text-transform: 13px;
            color: #000000;
          }

          &:after {
            position: relative;
            left: 0;
            right: 0;
            bottom: 30px;
            padding: 5px 1em 0;
            display: block;
            text-align: center;
            content: attr(value);
            word-wrap: break-word;
            color: #000000;
          }
        }
      }
    }
  }

  .hvac-form-calc-button {
    width: 100%;
  }

  .form-embed-link {
    margin: 0 auto;
    width: fit-content;
  }

  @media (max-width: 768px) {
    padding: 24px;

    .hvac-form--form {
      max-width: 552px;

      .hvac-form--form-item {
        margin-bottom: 24px;
      }

      .hvac-form--submit-button {
        width: 100%;
      }
    }
  }

  @media (max-width: 576px) {
    padding: 20px 24px;
    .hvac-form-right-container {
      margin-left: 0;

      .savings-circle-graph-container {
        flex-direction: column;
        .savings-item-column {
          width: 100%;
          text-align: center;
          .circular-chart-bottom {
            left: 68px;
          }
          .savings-percent-text-container {
            top: 206px;
            left: 93px;
          }
          h6 {
            margin-top: 30px;
          }
        }
      }
      .savings-bar-graph-container {
        height: auto;
        ul {
          padding-inline-start: 0;
        }
        .savings-bar-graph span {
          margin: 0 0.5em;
        }
        .savings-bar-graph span:after {
          padding: 0px;
        }
      }
      .section-gate-form--submit-form {
        width: 100%;
      }
    }
  }
  @media (max-width: 350px) {
    .savings-item-column {
      .circular-chart-bottom {
        left: 41px !important;
      }
      .savings-percent-text-container {
        left: 66px !important;
        top: 230px !important;
      }
    }
  }
`;

export const FormContainer = styled.div`
  margin-top: ${props => (props.isEmbed ? '0 !important' : '-100px')};
  padding-bottom: 100px;

  .section-tool-page-form--container {
    max-width: 1046px;
    margin: 0 auto;
    padding: 0 28px;

    ${props => (props.isEmbed ? `& > div {box-shadow: none !important;}` : '')}
  }

  @media (max-width: 768px) {
    margin-top: -70px;

    .section-tool-page-form--container {
      padding: 0 20px;
    }
  }
`;
